export const CREATE_PRODUCT_DENSITY = 'CREATE_PRODUCT_DENSITY'
export const GET_LIST_PRODUCT_DENSITY = 'GET_LIST_PRODUCT_DENSITY'
export const DETAIL_PRODUCT_DENSITY = 'DETAIL_PRODUCT_DENSITY'
export const PATCH_PRODUCT_DENSITY = 'PATCH_PRODUCT_DENSITY'
